import { lazy } from 'react';
import { authRoles } from 'app/auth';

const OrdersPage = lazy(() => import('./OrdersPage'));

const OrdersConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'orders/:mainTab/:subTab',
      element: <OrdersPage />,
    },
  ],
};

export default OrdersConfig;
